import React from 'react';
import { Button, Grid } from '@mui/material';
import BlockIcon from '@mui/icons-material/Block';
import CheckIcon from '@mui/icons-material/Check';
import DeleteIcon from '@mui/icons-material/Delete';

interface Props {
  onBlock?: () => void;
  onUnblock?: () => void;
  onDelete?: () => void;
  onAdd?: () => void;
  showBlock?: boolean;
  showUnblock?: boolean;
  showDelete?: boolean;
}

const ActionButtons: React.FC<Props> = ({ onBlock, onUnblock, onDelete, showBlock = true, showUnblock = true, showDelete = true }) => {
  return (
    <Grid container spacing={1}>
      {showBlock && (
        <Grid>
          <Button
            variant="outlined"
            color="warning"
            startIcon={<BlockIcon />}
            onClick={onBlock}
            size="small"
            sx={{
              textTransform: 'none',
              borderRadius: 2,
              '&:hover': {
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
              },
            }}
          >
            Block
          </Button>
        </Grid>
      )}
      {showUnblock && (
        <Grid>
          <Button
            variant="outlined"
            color="success"
            startIcon={<CheckIcon />}
            onClick={onUnblock}
            size="small"
            sx={{
              textTransform: 'none',
              borderRadius: 2,
              '&:hover': {
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
              },
            }}
          >
            Unblock
          </Button>
        </Grid>
      )}
      {showDelete && (
        <Grid>
          <Button
            variant="outlined"
            color="error"
            startIcon={<DeleteIcon />}
            onClick={onDelete}
            size="small"
            sx={{
              textTransform: 'none',
              borderRadius: 2,
              '&:hover': {
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
              },
            }}
          >
            Delete
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default ActionButtons;
